import * as React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { removeAllFilters } from '../redux-state/actions/filters';
import { IAppState } from '../classes/app';

interface StateToProps {
    total: number
    currPage: number;
    resultsPerPage: number;
}
interface ExternalProps {
    category: string

}

type ResultDashboardProps = ExternalProps & StateToProps;


class ResultDashboard extends React.Component<ResultDashboardProps> {


    render() {
        return (
            this.props.total > 0 ? <div>Showing {(this.props.currPage - 1) * this.props.resultsPerPage + 1} - {(this.props.total > this.props.currPage * this.props.resultsPerPage)?this.props.currPage * this.props.resultsPerPage : this.props.total} of {this.props.total} results</div> : <div>Showing {this.props.total} results</div>
        )
    }
}

export function mapStateToProps(state: IAppState, props: ExternalProps): StateToProps {
    return {
        total: state.listingState.totalResult,
        currPage: state.listingState.currPage,
        resultsPerPage: state.listingState.resultsPerPage
    }
}


export default connect<StateToProps>(mapStateToProps)(ResultDashboard);